module.exports = __webpack_public_path__ + "img/Werwolf.ade49031.jpg";